import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { style: { "border": "none" } };
const _hoisted_2 = { style: { "border": "none" } };
const _hoisted_3 = { class: "w-auto" };
const _hoisted_4 = { class: "text-start" };
import { DayOfWeek } from "@js-joda/core";
import { useI18n } from "vue-i18n";
import { PriceType } from "@/model/enum/PriceType.model";
import PriceStructure from "@/model/PriceStructure";
import { PricingByType } from "@/model/enum/PricingByType";
import { onMounted, reactive, ref, watch } from "vue";
import EditPriceAdjustmentPanel from "@/components/admin/EditPriceAdjustmentPanel.vue";
import PriceRow from "@/components/admin/PriceRow.vue";
import PriceAdjustment from "@/model/PriceAdjustment";
import { getAssignedResources } from "@/model/Product";
import { ResourceType } from "@/model/enum/ResourceType";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPricePanel',
    props: {
        priceStructure: { type: PriceStructure, required: true },
        product: { type: Object, required: true }
    },
    emits: ['update:priceStructure'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const props = __props;
        const emits = __emit;
        const localPriceStructure = reactive(new PriceStructure());
        const priceAdjustmentDialog = ref(false);
        const selectedPriceAdjustment = ref(new PriceAdjustment());
        const selectedPriceAdjustmentIndex = ref(-1);
        onMounted(() => {
            localPriceStructure.init(props.priceStructure);
        });
        watch(() => props.priceStructure, (newValue) => {
            localPriceStructure.init(newValue);
        }, { deep: true });
        function onPriceUpdated(day, priceType, referenceId, amount, lowerBound) {
            if (!localPriceStructure.prices.has(day)) {
                localPriceStructure.prices.set(day, new Map());
            }
            if (!localPriceStructure.prices.get(day).has(priceType)) {
                localPriceStructure.prices.get(day).set(priceType, new Map());
            }
            let priceObj;
            if (localPriceStructure.prices.get(day).get(priceType).has(referenceId)) {
                priceObj = localPriceStructure.prices.get(day).get(priceType).get(referenceId);
            }
            else {
                priceObj = {};
                localPriceStructure.prices.get(day).get(priceType).set(referenceId, priceObj);
            }
            priceObj.amount = amount;
            priceObj.lowerBound = lowerBound;
            emits("update:priceStructure", localPriceStructure);
        }
        function onPricingByTypeUpdated(type, active) {
            if (active) {
                localPriceStructure.pricingByTypes.push(type);
            }
            else {
                localPriceStructure.pricingByTypes.splice(localPriceStructure.pricingByTypes.indexOf(type), 1);
            }
            emits("update:priceStructure", localPriceStructure);
        }
        function onPriceAdjustmentUpdated(priceAdjustment) {
            if (selectedPriceAdjustmentIndex.value >= 0) {
                localPriceStructure.priceAdjustments[selectedPriceAdjustmentIndex.value] = priceAdjustment;
            }
            else {
                localPriceStructure.priceAdjustments.push(priceAdjustment);
            }
            selectedPriceAdjustment.value = new PriceAdjustment();
            selectedPriceAdjustmentIndex.value = -1;
            priceAdjustmentDialog.value = false;
            emits("update:priceStructure", localPriceStructure);
        }
        function onAbortDialog() {
            selectedPriceAdjustment.value = new PriceAdjustment();
            selectedPriceAdjustmentIndex.value = -1;
            priceAdjustmentDialog.value = false;
        }
        function editPriceAdjustment(priceAdjustment, index) {
            selectedPriceAdjustment.value = priceAdjustment;
            selectedPriceAdjustmentIndex.value = index;
            priceAdjustmentDialog.value = true;
        }
        function deletePriceAdjustment(index) {
            localPriceStructure.priceAdjustments.splice(index, 1);
            emits("update:priceStructure", localPriceStructure);
        }
        return (_ctx, _cache) => {
            const _component_v_switch = _resolveComponent("v-switch");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex flex-wrap v-col-12" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_table, { class: "w-100" }, {
                        default: _withCtx(() => [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _cache[3] || (_cache[3] = _createElementVNode("th", null, "Abrechnung nach", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DayOfWeek).values(), (day) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                            key: day.value()
                                        }, _toDisplayString(_unref(t)(day.toString())), 1));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_1, [
                                        _createVNode(_component_v_switch, {
                                            "model-value": __props.priceStructure.isPricingByFlatrate(),
                                            "hide-details": true,
                                            label: "Pauschalpreis",
                                            color: "green",
                                            onChange: _cache[0] || (_cache[0] = ($event) => (onPricingByTypeUpdated(_unref(PricingByType).BY_FLAT_RATE, $event.target.checked))),
                                            density: "compact",
                                            "data-cy": "pricingByBooking"
                                        }, null, 8, ["model-value"])
                                    ])
                                ]),
                                (__props.priceStructure.isPricingByFlatrate())
                                    ? (_openBlock(), _createBlock(PriceRow, {
                                        key: 0,
                                        label: "Pauschalpreis",
                                        "price-type": _unref(PriceType).FLAT_RATE,
                                        referenceId: null,
                                        prices: __props.priceStructure.prices,
                                        "onUpdate:price": onPriceUpdated
                                    }, null, 8, ["price-type", "prices"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_2, [
                                        _createVNode(_component_v_switch, {
                                            "model-value": __props.priceStructure.isPricingByResources(),
                                            "hide-details": true,
                                            label: "Eigenschaften & Ressourcen",
                                            color: "green",
                                            onChange: _cache[1] || (_cache[1] = ($event) => (onPricingByTypeUpdated(_unref(PricingByType).BY_RESOURCE, $event.target.checked))),
                                            density: "compact",
                                            "data-cy": "pricingByResources"
                                        }, null, 8, ["model-value"])
                                    ])
                                ]),
                                (__props.priceStructure.isPricingByResources())
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAssignedResources)(__props.product, _unref(ResourceType).ATTRIBUTE), (resource) => {
                                            return (_openBlock(), _createBlock(PriceRow, {
                                                key: resource.id,
                                                label: resource.name,
                                                "price-type": _unref(PriceType).PER_RESOURCE,
                                                referenceId: resource.id,
                                                prices: __props.priceStructure.prices,
                                                "onUpdate:price": onPriceUpdated
                                            }, null, 8, ["label", "price-type", "referenceId", "prices"]));
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAssignedResources)(__props.product, _unref(ResourceType).RESOURCE), (resource) => {
                                            return (_openBlock(), _createBlock(PriceRow, {
                                                key: resource.id,
                                                label: resource.name,
                                                "price-type": _unref(PriceType).PER_RESOURCE,
                                                referenceId: resource.id,
                                                prices: __props.priceStructure.prices,
                                                "onUpdate:price": onPriceUpdated
                                            }, null, 8, ["label", "price-type", "referenceId", "prices"]));
                                        }), 128))
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_table, { class: "w-100" }, {
                        default: _withCtx(() => [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _cache[5] || (_cache[5] = _createElementVNode("th", { class: "w-66" }, "Rabatte & Gebühren", -1)),
                                    _cache[6] || (_cache[6] = _createElementVNode("th", { class: "w-33" }, "Gültige Tage", -1)),
                                    _createElementVNode("th", _hoisted_3, [
                                        _createVNode(_component_v_dialog, {
                                            modelValue: priceAdjustmentDialog.value,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((priceAdjustmentDialog).value = $event)),
                                            "max-width": "1200px"
                                        }, {
                                            activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "addPriceAdjustment" }), {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { color: "white" }, {
                                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                                _createTextVNode("mdi-plus")
                                                            ])),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 2
                                                }, 1040)
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(EditPriceAdjustmentPanel, {
                                                    "price-adjustment": selectedPriceAdjustment.value,
                                                    product: __props.product,
                                                    onUpdatePriceAdjustment: onPriceAdjustmentUpdated,
                                                    onCloseDialog: onAbortDialog
                                                }, null, 8, ["price-adjustment", "product"])
                                            ]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ])
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localPriceStructure.priceAdjustments, (priceAdjustment, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", null, _toDisplayString(priceAdjustment.name), 1),
                                        _createElementVNode("td", _hoisted_4, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceAdjustment.daysOfWeek, (day, index) => {
                                                return (_openBlock(), _createBlock(_component_v_chip, {
                                                    key: index,
                                                    size: "small",
                                                    class: "me-1",
                                                    color: "primary"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)(day.toString())), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024));
                                            }), 128))
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_v_icon, {
                                                class: "me-2",
                                                color: "info",
                                                size: "small",
                                                onClick: ($event) => (editPriceAdjustment(priceAdjustment, index))
                                            }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                    _createTextVNode(" mdi-pencil ")
                                                ])),
                                                _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_icon, {
                                                size: "small",
                                                color: "error",
                                                onClick: ($event) => (deletePriceAdjustment(index))
                                            }, {
                                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                    _createTextVNode(" mdi-delete ")
                                                ])),
                                                _: 2
                                            }, 1032, ["onClick"])
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
